<h1>Contact Details</h1>
<form [formGroup]="form" method="post" class="form">
  <ol class="questions">
    <li>
      <fieldset>
        <legend> <span class="label">Are you the landholder?</span> <abbr title="(required)"
      class="required">*</abbr>
    </legend>
    <ul class="choices">
      <li> <input type="radio" formControlName="areYouTheLandholder" [value]="true" required="required"
        id="areYouTheLandholder-yes" />
        <label for="areYouTheLandholder-yes">Yes</label>
      </li>
      <li> <input type="radio" formControlName="areYouTheLandholder" [value]="false" required="required"
        id="areYouTheLandholder-no" /> <label for="areYouTheLandholder-no">No, I am notifying on behalf of
      the landholder</label> </li>
    </ul>
  </fieldset>
</li>
@if (areYouTheLandholder === false) {
  <div>
    <li>
      <fieldset>
        <legend> <span class="label">Are you authorised to notify on behalf of the landholder?</span> <abbr
      title="(required)" class="required">*</abbr>
    </legend>
    <ul class="choices">
      <li> <input type="radio" formControlName="areYouAuthorised" [value]="true" required="required"
        id="areYouAuthorised-yes" />
        <label for="areYouAuthorised-yes">Yes</label>
      </li>
      <li> <input type="radio" formControlName="areYouAuthorised" [value]="false" required="required"
        id="areYouAuthorised-no" /> <label for="areYouAuthorised-no">No</label> </li>
      </ul>
    </fieldset>
  </li>
  @if (areYouAuthorised) {
    <li>
      <fieldset>
        <legend> <span class="label">Are you an officer of the Department of Natural Resources and Mines, Manufacturing and Regional and Rural Development?</span> <abbr title="(required)" class="required">*</abbr>
      </legend>
      <ul class="choices">
        <li> <input type="radio" formControlName="areYouLandsOfficer" [value]="true" required="required"
          id="areYouLandsOfficer-yes" />
          <label for="areYouLandsOfficer-yes">Yes</label>
        </li>
        <li> <input type="radio" formControlName="areYouLandsOfficer" [value]="false"
          required="required" id="areYouLandsOfficer-no" /> <label
        for="areYouLandsOfficer-no">No</label> </li>
      </ul>
    </fieldset>
  </li>
}
@if (areYouAuthorised === false) {
  <li>
    <p> </p>
    <div class="alert alert-warning mt-4" role="alert">
      <h2><i class="fa fa-exclamation-triangle"></i>Cannot continue</h2>
      <p>You cannot submit a notification on behalf of a landholder unless you have first obtained
      authorisation from the landholder.</p>
    </div>
  </li>
}
</div>
}
</ol>

<li class="footer">
  <ul class="actions">
    <li> <input class="qg-btn btn-global-secondary" type="submit" (click)="previous()" value="Previous" /> </li>
    <li> <em> <input [disabled]="!isAllowedToContinue" class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /> </em> </li>
  </ul>
</li>
</form>
